module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "start-here container"
  }, [_c('h2', [_vm._v("Start here for...")]), _vm._v(" "), _c('div', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Category',
        params: {
          topic: 'laugh'
        }
      }
    }
  }, [_c('span', [_vm._v("A Laugh")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'Category',
        params: {
          topic: 'good-cry'
        }
      }
    }
  }, [_c('span', [_vm._v("A Good Cry")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'Category',
        params: {
          topic: 'surprise'
        }
      }
    }
  }, [_c('span', [_vm._v("A Surprise")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'Category',
        params: {
          topic: 'staff-faves'
        }
      }
    }
  }, [_c('span', [_vm._v("Staff Faves")])])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-993b45cc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/StartHere.vue
// module id = 798
// module chunks = 1